import { render, staticRenderFns } from "./DeliveryCar.vue?vue&type=template&id=63e099b8&scoped=true&"
import script from "./DeliveryCar.vue?vue&type=script&lang=js&"
export * from "./DeliveryCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e099b8",
  null
  
)

export default component.exports